import axios from 'src/libs/axios';
import { QueryFunctionContext } from '@tanstack/react-query';

const getInitLogin = (args: QueryFunctionContext<any>) => {
  const [url, params] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
  });
};

export default { getInitLogin };
